<template>
    <div :id="id" class="border rounded overflow-hidden"/>
</template>

<script>
import Coloris from '@melloware/coloris'

export default {
    props: {
        value: String,
        alpha: Boolean
    },

    mounted() {
        Coloris.init()

        Coloris({
            alpha: this.alpha,
            theme: 'polaroid',
            themeMode: 'light',
            format: 'hex',
            defaultColor: this.value,
            parent: '#' + this.id,
            formatToggle: false,
            inline: true,
        })

        document.addEventListener('coloris:pick', event => {
            this.$emit('input', event.detail.color)
        })
    },

    computed: {
        id() {
            return 'COLORIS' + Math.random().toString().replace('.', '')
        },
    },
}
</script>

<style src="@melloware/coloris/dist/coloris.css" lang="css"></style>
<style>
.clr-picker {
    box-shadow: none !important;
    width: 100%;
}
</style>
